import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { hasValidator } from '../_helpers/functions';
import { SelectOptions } from '../models/select.model';

@Component({
    selector: 'sume-select',
    templateUrl: './select.component.html',
})
export class SelectComponent implements OnInit, OnChanges, AfterViewInit {
    @Input() label: string;
    @Input() controlName: string;
    @Input() formGroup: FormGroup;

    @Input() objectValueName: string = 'value';
    @Input() objectLabelName: string = 'text';
    @Input() items: SelectOptions[] | any[];

    @Input() messages: any;
    @Input() helpMessage: string;
    @Input() changeText = false;
    @Input() disable_default = true;
    @Input() displayLabel = true;

    @Output() current = new EventEmitter<any>();
    isRequired = false;

    subscriptions: Subscription[] = [];

    get formControl() {
        return this.formGroup.get(this.controlName);
    }

    constructor(private cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
        this.formControl?.valueChanges.subscribe(_ =>
            this.setControlAndValueToSameType()
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.setControlAndValueToSameType();
    }

    /**
     * Converte Label em id caso a API retorne a instância sem id, mas espere o id como retorno.
     *
     *  Por exemplo:
     * Suponha que o select deve ter o seguinte par chave-valor
     * ```
     * itens = [{id_tp_instituicao: number, tp_instituicao: string}, ...]
     * ```
     *
     * Mas a API não retornou o id
     * ```
     * {
     *    ...,
     *    tp_instituicao: string
     * }
     * ```
     *
     */
    setControlAndValueToSameType() {
        if (!this.items) return;
        if (this.items.length === 0) return;
        if (!this.formControl) return;
        if (
            typeof this.items[0][this.objectValueName] ===
            typeof this.formControl.value
        )
            return;

        const item = this.items.find(
            el => el[this.objectLabelName] === this.formControl?.value
        );

        if (!item) return;

        this.formControl.setValue(item[this.objectValueName]);
    }

    ngAfterViewInit(): void {
        if (!this.formControl) {
            console.log('Erro ao verificar se o campo é obrigatório');
            console.log('formControl nulo');
        } else {
            this.isRequired = hasValidator(this.formControl, 'required');
            this.cdr.detectChanges();
        }
    }

    onSelect() {
        this.current.emit(this.formControl.value);
    }
}
